import {useMutation} from "@apollo/client";
import {AddArticleToIssueDocument, AddArticleToIssueInput} from "generated/graphql";

export const useAddArticleToIssue = () => {
  const [mutate] = useMutation(AddArticleToIssueDocument);

  return (input: AddArticleToIssueInput) => mutate({ variables: { input }});
}